<template>
  <div class="filters">
    <div id="aaa">
      <div class="jump-btn">
        <el-button type="primary" @click="jump">返回列表</el-button>
      </div>
      <!-- 个人信息 -->
      <div class="personInfoBox">
        <el-collapse @change="handleChange">
          <el-collapse-item title="个人情况:（可点击查看此项说明）" name="1">
            <div>填写本人的基本信息</div>
          </el-collapse-item>
        </el-collapse>
        <div class="topBox">
          <span class="mr10 c-676a6c">部门</span>
          <el-select :disabled="true" v-model="formData.sectionValue" filterable placeholder="请选择部门">
            <el-option v-for="item in sectionOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="topBox">
          <span class="mr10 c-676a6c">职务</span>
          <el-select :disabled="true" v-model="formData.jobValue" filterable placeholder="请选择职务">
            <el-option v-for="item in jobOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="topBox">
          <span class="mr10 c-676a6c">直接主管</span>
          <el-select :disabled="true" v-model="formData.leaderValue" filterable placeholder="请选择直接主管">
            <el-option v-for="item in leaderOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <p class="mtb10  c-676a6c">换岗经历</p>
        <el-input :disabled="true" type="textarea" :rows="4" placeholder="换岗经历" v-model="formData.changeJobTxt">
        </el-input>
      </div>
      <!-- 工作结果及自评 -->
      <div class="workResults">
        <el-collapse @change="handleChange">
          <el-collapse-item title="工作结果及自评:（可点击查看此项说明）" name="2">
            <div>回顾上一阶段你参与的最重要的3-5个工作/任务（如设有既定发展计划的将作为其中一项主要工作），说明完成上述工作/任务的标志或你和直接上级达成的共同期望是什么。
              对比标志或期望评估目前的现状如何。用远远超过、超过、达到、部分达到、没达到来表示。针既定发展计划，用已完成、部分完成、未完成来表示。
              根据员工日常表现进行评估。员工与直接上级都要以事实说话，通过积极交流，双方对评估观点、意见、结果达成共识。</div>
          </el-collapse-item>
        </el-collapse>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="工作总结1" name="summary1">
            <p class="mtb10  c-676a6c">最重要的工作/任务</p>
            <el-input :disabled="true" type="textarea" :rows="3" placeholder="最重要的工作/任务" v-model="formData.majorWork1">
            </el-input>
            <div class="evaluateBoxs">
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">客户满意度</span>
                <el-select :disabled="true" v-model="formData.evaluateValue1_1" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue1_1" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">进度</span>
                <el-select :disabled="true" v-model="formData.evaluateValue1_2" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue1_2" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">质量</span>
                <el-select :disabled="true" v-model="formData.evaluateValue1_3" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue1_3" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">数量</span>
                <el-select :disabled="true" v-model="formData.evaluateValue1_4" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue1_4" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">费用</span>
                <el-select :disabled="true" v-model="formData.evaluateValue1_5" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue1_5" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工作总结2" name="summary2">
            <p class="mtb10  c-676a6c">最重要的工作/任务</p>
            <el-input :disabled="true" type="textarea" :rows="3" placeholder="最重要的工作/任务" v-model="formData.majorWork2">
            </el-input>
            <div class="evaluateBoxs">
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">客户满意度</span>
                <el-select :disabled="true" v-model="formData.evaluateValue2_1" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue2_1" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">进度</span>
                <el-select :disabled="true" v-model="formData.evaluateValue2_2" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue2_2" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">质量</span>
                <el-select :disabled="true" v-model="formData.evaluateValue2_3" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue2_3" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">数量</span>
                <el-select :disabled="true" v-model="formData.evaluateValue2_4" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue2_4" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">费用</span>
                <el-select :disabled="true" v-model="formData.evaluateValue2_5" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue2_5" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工作总结3" name="summary3">
            <p class="mtb10  c-676a6c">最重要的工作/任务</p>
            <el-input :disabled="true" type="textarea" :rows="3" placeholder="最重要的工作/任务" v-model="formData.majorWork3">
            </el-input>
            <div class="evaluateBoxs">
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">客户满意度</span>
                <el-select :disabled="true" v-model="formData.evaluateValue3_1" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue3_1" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">进度</span>
                <el-select :disabled="true" v-model="formData.evaluateValue3_2" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue3_2" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">质量</span>
                <el-select :disabled="true" v-model="formData.evaluateValue3_3" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue3_3" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">数量</span>
                <el-select :disabled="true" v-model="formData.evaluateValue3_4" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue3_4" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">费用</span>
                <el-select :disabled="true" v-model="formData.evaluateValue3_5" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue3_5" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工作总结4" name="summary4">
            <p class="mtb10  c-676a6c">最重要的工作/任务</p>
            <el-input :disabled="true" type="textarea" :rows="3" placeholder="最重要的工作/任务" v-model="formData.majorWork4">
            </el-input>
            <div class="evaluateBoxs">
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">客户满意度</span>
                <el-select :disabled="true" v-model="formData.evaluateValue4_1" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue4_1" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">进度</span>
                <el-select :disabled="true" v-model="formData.evaluateValue4_2" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue4_2" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">质量</span>
                <el-select :disabled="true" v-model="formData.evaluateValue4_3" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue4_3" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">数量</span>
                <el-select :disabled="true" v-model="formData.evaluateValue4_4" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue4_4" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">费用</span>
                <el-select :disabled="true" v-model="formData.evaluateValue4_5" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue4_5" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工作总结5" name="summary5">
            <p class="mtb10  c-676a6c">最重要的工作/任务</p>
            <el-input :disabled="true" type="textarea" :rows="3" placeholder="最重要的工作/任务" v-model="formData.majorWork5">
            </el-input>
            <div class="evaluateBoxs">
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">客户满意度</span>
                <el-select :disabled="true" v-model="formData.evaluateValue5_1" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue5_1" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">进度</span>
                <el-select :disabled="true" v-model="formData.evaluateValue5_2" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue5_2" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">质量</span>
                <el-select :disabled="true" v-model="formData.evaluateValue5_3" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue5_3" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">数量</span>
                <el-select :disabled="true" v-model="formData.evaluateValue5_4" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue5_4" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">费用</span>
                <el-select :disabled="true" v-model="formData.evaluateValue5_5" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select class="ml20" v-model="formData.superiorValue5_5" filterable placeholder="上级审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>

        </el-tabs>
      </div>
      <!-- 改进及发展计划 -->
      <div class="improvementPlan">
        <el-collapse @change="handleChange">
          <el-collapse-item title="改进及发展计划:（可点击查看此项说明）" name="3">
            <div>根据评估结果和客户/上级/同事/供应商对不足之处的反馈。 重点应放在可能对提高未来工作绩效影响最大的少数需改进地方（素质能力、专业技能等）。
              明确直接上级及员工个人为支持员工专业发展和职业兴趣将采取的具体的行动及时间计划。改进不足要与其下一步工作相联系，没有适合的工作，
              员工的不足不可能光凭注意就能发展起来。发展的愿望和责任在于员工，直接上级的作用是辅佐、支持、成为导师。</div>
          </el-collapse-item>
          <div class="textareaBox">
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">现有长处所在</p>
              <el-input :disabled="true" type="textarea" :rows="4" placeholder="现有长处所在"
                v-model="formData.improvementPlanTxt1">
              </el-input>
            </div>
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">提高新的高度/水平是什么</p>
              <el-input :disabled="true" type="textarea" :rows="4" placeholder="提高新的高度/水平是什么"
                v-model="formData.improvementPlanTxt2">
              </el-input>
            </div>
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">采取的行动计划</p>
              <el-input :disabled="true" type="textarea" :rows="4" placeholder="采取的行动计划"
                v-model="formData.improvementPlanTxt3">
              </el-input>
            </div>
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">需要改进方面</p>
              <el-input :disabled="true" type="textarea" :rows="4" placeholder="需要改进方面"
                v-model="formData.improvementPlanTxt4">
              </el-input>
            </div>
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">改进的目标</p>
              <el-input :disabled="true" type="textarea" :rows="4" placeholder="改进的目标"
                v-model="formData.improvementPlanTxt5">
              </el-input>
            </div>
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">采取的行动计划</p>
              <el-input :disabled="true" type="textarea" :rows="4" placeholder="采取的行动计划"
                v-model="formData.improvementPlanTxt6">
              </el-input>
            </div>
          </div>
        </el-collapse>
      </div>
      <!-- 职业发展兴趣 -->
      <div class="improvementPlan">
        <el-collapse @change="handleChange">
          <el-collapse-item title="职业发展兴趣:（可点击查看此项说明）" name="4">
            <div>这一回顾有助于计划好员工个人与公司业务的一致性。但这不是个合同。员工的实际进展将取决于员工个人发展及公司业务需要。 上级的评论，不视为承诺，再上级要知道并在适当的时候给予指导评论</div>
          </el-collapse-item>
          <div class="textareaBox">
            <div class="textareaBox2">
              <p class="mtb10 c-676a6c">个人短期职业兴趣（1-2年）</p>
              <el-input :disabled="true" type="textarea" :rows="4" placeholder="个人短期职业兴趣（1-2年）"
                v-model="formData.interest1">
              </el-input>
            </div>
            <div class="textareaBox2">
              <p class="mtb10 c-676a6c">个人长期职业兴趣（5年左右）</p>
              <el-input :disabled="true" type="textarea" :rows="4" placeholder="个人长期职业兴趣（5年左右）"
                v-model="formData.interest2">
              </el-input>
            </div>
            <div class="textareaBox1">
              <p class="mtb10 c-676a6c">工作地点的灵活度(请在下列地点中选择)：SOHO，繁荣里，康泉府，馨港湾，自由成，阳光城，喜鹊，木棉花一期，常青藤，生活坊一期，
                生活坊二期，生活坊三期，生活坊四期，生活坊五期，玫瑰湾（一期），豪森，春晓，梦夏（可填写多个）</p>
              <el-input :disabled="true" type="textarea" :rows="4" placeholder="工作地点的灵活度"
                v-model="formData.workAddress">
              </el-input>
            </div>
          </div>
        </el-collapse>
      </div>
      <!-- 上级综合评估 -->
      <div class="improvementPlan">
        <el-collapse @change="handleChange">
          <el-collapse-item title="上级综合评估:（可点击查看此项说明）" name="4">
            <div>由上级完成，描述该员工上一年度/阶段工作与发展达成目标的总体情况。结合主要客户的反馈，表明员工工作结果达到岗位职责要求、工作计划要求的程度。
              应明确指出该员工在回顾时间段内总体上是超出，达到还是未能达到设定的期望。认可其取得的主要成绩，并指出哪些方面未达到上一个阶段的工作及发展要求。
              如果有的话，指出哪些关键工作内容及期望，没有达成目标。指出其个人的主要优点不足，发展方向及潜力，下一步工作中要注意的问题。 在与员工达不成一致的时候以直接上级与再上级的共同意见为准。
              上级的评论，不视为承诺，再上级要知道并在适当的时候给予指导评论</div>
          </el-collapse-item>
          <div class="topBox">
            <span class="mr10 c-676a6c">绩效评估</span>
            <el-select v-model="formData.meritsValue" filterable placeholder="绩效评估">
              <el-option v-for="item in meritsOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="textareaBox">
            <div class="textareaBox4">
              <p class="mtb10 c-676a6c">关键目标完成情况</p>
              <el-input type="textarea" :rows="4" placeholder="关键目标完成情况" v-model="formData.meritsTxt1">
              </el-input>
            </div>
            <div class="textareaBox4">
              <p class="mtb10 c-676a6c">强项</p>
              <el-input type="textarea" :rows="4" placeholder="强项" v-model="formData.meritsTxt2">
              </el-input>
            </div>
            <div class="textareaBox4">
              <p class="mtb10 c-676a6c">关键目标未完成情况</p>
              <el-input type="textarea" :rows="4" placeholder="关键目标未完成情况" v-model="formData.meritsTxt3">
              </el-input>
            </div>
            <div class="textareaBox4">
              <p class="mtb10 c-676a6c">弱项</p>
              <el-input type="textarea" :rows="4" placeholder="弱项" v-model="formData.meritsTxt4">
              </el-input>
            </div>
            <div class="textareaBox1">
              <p class="mtb10 c-676a6c">上级意见</p>
              <el-input type="textarea" :rows="4" placeholder="上级意见" v-model="formData.meritsTxt5">
              </el-input>
            </div>
          </div>
        </el-collapse>
      </div>
      <el-button class="btn-first" type="primary" @click="onSave">保存</el-button>
      <el-button class="detailbtn" type="primary" @click="onSubmit">确定</el-button>
      <el-button class="detailbtn" type="primary" @click="reject">驳回修改</el-button>
      <p class="c-676a6c">（保存：保存本页信息，可更改。 确定:通过此次自评,确定后不可修改并提交！ 驳回修改：不通过此次自评，驳回给当事人重新自评！）</p>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        sectionOptions: [{
          value: '部门111',
          label: '部门1'
        }, {
          value: '部门222',
          label: '部门2'
        }, {
          value: '部门333',
          label: '部门3'
        }], //部门list
        jobOptions: [{
          value: '经理',
          label: '经理'
        }, {
          value: '主管',
          label: '主管'
        }, {
          value: '专员',
          label: '专员'
        }], //职务list
        leaderOptions: [{
          value: '领导111',
          label: '领导1'
        }, {
          value: '领导222',
          label: '领导2'
        }, {
          value: '领导333',
          label: '领导3'
        }], //直接主管list
        evaluateOptions: [{
          value: '远远超过',
          label: '远远超过'
        }, {
          value: '超过',
          label: '超过'
        }, {
          value: '达到',
          label: '达到'
        }, {
          value: '部分达到',
          label: '部分达到'
        }, {
          value: '没达到',
          label: '没达到'
        }], //自我审批list
        meritsOptions: [{
          value: '1',
          label: 'A'
        }, {
          value: '2',
          label: 'B'
        }, {
          value: '3',
          label: 'C'
        }, {
          value: '4',
          label: 'D'
        }], //绩效评估list
        activeName: 'summary1', //工作总结默认tab
        formData: {
          sectionValue: '', //选择的部门值
          jobValue: '', //选择的职务值
          leaderValue: '', //选择的直接主管值
          changeJobTxt: '', //换岗经历

          majorWork1: '', //重要工作、任务1
          majorWork2: '', //重要工作、任务2
          majorWork3: '', //重要工作、任务3
          majorWork4: '', //重要工作、任务4
          majorWork5: '', //重要工作、任务5

          evaluateValue1_1: '', //工作总结1-客户满意度
          evaluateValue1_2: '', //工作总结1-进度
          evaluateValue1_3: '', //工作总结1-质量
          evaluateValue1_4: '', //工作总结1-数量
          evaluateValue1_5: '', //工作总结1-费用

          evaluateValue2_1: '', //工作总结2-客户满意度
          evaluateValue2_2: '', //工作总结2-进度
          evaluateValue2_3: '', //工作总结2-质量
          evaluateValue2_4: '', //工作总结2-数量
          evaluateValue2_5: '', //工作总结2-费用

          evaluateValue3_1: '', //工作总结3-客户满意度
          evaluateValue3_2: '', //工作总结3-进度
          evaluateValue3_3: '', //工作总结3-质量
          evaluateValue3_4: '', //工作总结3-数量
          evaluateValue3_5: '', //工作总结3-费用

          evaluateValue4_1: '', //工作总结4-客户满意度
          evaluateValue4_2: '', //工作总结4-进度
          evaluateValue4_3: '', //工作总结4-质量
          evaluateValue4_4: '', //工作总结4-数量
          evaluateValue4_5: '', //工作总结4-费用

          evaluateValue5_1: '', //工作总结5-客户满意度
          evaluateValue5_2: '', //工作总结5-进度
          evaluateValue5_3: '', //工作总结5-质量
          evaluateValue5_4: '', //工作总结5-数量
          evaluateValue5_5: '', //工作总结5-费用

          superiorValue1_1: '', //工作总结1-客户满意度-上级审评
          superiorValue1_2: '', //工作总结1-进度-上级审评
          superiorValue1_3: '', //工作总结1-质量-上级审评
          superiorValue1_4: '', //工作总结1-数量-上级审评
          superiorValue1_5: '', //工作总结1-费用-上级审评

          superiorValue2_1: '', //工作总结2-客户满意度-上级审评
          superiorValue2_2: '', //工作总结2-进度-上级审评
          superiorValue2_3: '', //工作总结2-质量-上级审评
          superiorValue2_4: '', //工作总结2-数量-上级审评
          superiorValue2_5: '', //工作总结2-费用-上级审评

          superiorValue3_1: '', //工作总结3-客户满意度-上级审评
          superiorValue3_2: '', //工作总结3-进度-上级审评
          superiorValue3_3: '', //工作总结3-质量-上级审评
          superiorValue3_4: '', //工作总结3-数量-上级审评
          superiorValue3_5: '', //工作总结3-费用-上级审评

          superiorValue4_1: '', //工作总结4-客户满意度-上级审评
          superiorValue4_2: '', //工作总结4-进度-上级审评
          superiorValue4_3: '', //工作总结4-质量-上级审评
          superiorValue4_4: '', //工作总结4-数量-上级审评
          superiorValue4_5: '', //工作总结4-费用-上级审评

          superiorValue5_1: '', //工作总结5-客户满意度-上级审评
          superiorValue5_2: '', //工作总结5-进度-上级审评
          superiorValue5_3: '', //工作总结5-质量-上级审评
          superiorValue5_4: '', //工作总结5-数量-上级审评
          superiorValue5_5: '', //工作总结5-费用-上级审评

          improvementPlanTxt1: '', //改进及发展计划textarea1
          improvementPlanTxt2: '', //改进及发展计划textarea2
          improvementPlanTxt3: '', //改进及发展计划textarea3
          improvementPlanTxt4: '', //改进及发展计划textarea4
          improvementPlanTxt5: '', //改进及发展计划textarea5
          improvementPlanTxt6: '', //改进及发展计划textarea6

          interest1: '', //短期兴趣
          interest2: '', //长期兴趣
          workAddress: '', //工作地点
          meritsValue: '', //绩效评估的值

          meritsTxt1: '', //关键目标完成情况
          meritsTxt2: '', //强项
          meritsTxt3: '', //关键目标未完成情况
          meritsTxt4: '', //弱项
          meritsTxt5: '', //上级意见

        }

      }
    },
    computed: {

    },
    methods: {
      handleChange(val) {
        console.log(val);
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      // 返回列表
      jump() {
        this.$router.push({
          name: 'superiorAssessmentFormList'
        })
      },
      // 保存
      onSave() {
        console.log(this.formData)
      },
      // 提交
      onSubmit() {
        console.log(this.formData)
      },
      // 驳回修改
      reject(){
        console.log(this.formData)
      }

    },
    mounted() {

    }
  }
</script>
<style lang="scss">
  #aaa {
    padding: 0 100px;

    .personInfoBox {
      padding-bottom: 30px;
      // border-bottom: 2px solid #d8d8d8;
    }

    .el-collapse {
      border-bottom: none !important;
    }

    .el-collapse .el-collapse-item__header {
      font-size: 20px !important;
      margin: 10px 0 !important;
      border-bottom: none !important;
      font-weight: bold;
    }

    .el-collapse .el-collapse-item__wrap {
      font-size: 20px !important;
      border-bottom: none !important;
    }

    .el-collapse .el-collapse-item__content {
      font-size: 16px;
      font-weight: bold;
    }

    .topBox {
      // flex: 1;
      width: 33%;
      display: inline-block;
    }

    .evaluateBox {
      width: 100%;
      margin: 15px 0;
    }

    .evaluateBox span.w-100 {
      display: inline-block;
      width: 100px;

    }

    .evaluateBox .el-select {
      width: 40% !important;
    }

    .ml20 {
      margin-left: 20px;
    }

    .mr10 {
      margin-right: 10px;
    }

    .topBox .el-select {
      width: 70% !important;
    }

    .mtb10 {
      margin: 10px 0 5px;
    }

    // .el-textarea__inner {
    //   width: 94%;
    // }

    .textareaBox {
      // width: 97%;
      margin-bottom: 30px;
    }

    .textareaBox3 {
      width: 30%;
      margin-right: 3%;
      display: inline-block;
    }

    .textareaBox2 {
      width: 45%;
      margin-right: 3%;
      display: inline-block;
    }

    .textareaBox4 {
      width: 22%;
      margin-right: 3%;
      display: inline-block;
    }

    .textareaBox1 {
      width: 100%!important;
      display: inline-block;
    }

    .c-676a6c {
      font-weight: bold;
      color: #676a6c !important;
    }

    .el-tabs__nav-wrap {
      position: absolute !important;
      ;
    }

    .manage .el-tabs {
      background-color: #fff;
    }

    .el-tabs__content {
      background-color: #fff;
      padding-top: 50px;
      padding-bottom: 30px;
    }

    .el-tabs__item {
      padding: 0 70px;
    }

    .tabs__item.is-top:nth-child(2) {
      padding-left: 70px;
    }

    .tabs__item.is-top:last-child {
      padding-right: 70px;
    }

    .el-tab-pane {
      width: 75%;
    }
  }
</style>